export const column = [
  {
    field: 'emailId',
    headerName: 'User Email',
    flex: 1,
    minWidth: 260,
    isVisible: true,
    index: 1,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    minWidth: 160,
    isVisible: true,
    index: 2,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    flex: 1,
    minWidth: 160,
    isVisible: true,
    index: 3,
  },
  {
    field: 'projectLabel',
    headerName: 'Project',
    flex: 1,
    minWidth: 120,
    isVisible: true,
    index: 4,
  },
  {
    field: 'roleLabel',
    headerName: 'Role',
    flex: 1,
    minWidth: 120,
    isVisible: true,
    index: 5,
  },
  {
    field: 'inTime',
    headerName: 'Login Date/Time (UTC)',
    minWidth: 200,
    isVisible: true,
    index: 6,
  },
  {
    field: 'outTime',
    headerName: 'Logout Date/Time (UTC)',
    flex: 1,
    minWidth: 200,
    isVisible: true,
    index: 7,
  },
];
